import l from "../../../../@babel/runtime/helpers/esm/extends2.mjs";
import c from "../../../../classnames/index2.mjs";
import f from "../../../../rc-motion/es/CSSMotion.mjs";
import "../../../../rc-motion/es/CSSMotionList.mjs";
import * as t from "react";
function k(e) {
  var n = e.prefixCls, r = e.open, a = e.zIndex, m = e.mask, o = e.motion;
  return m ? /* @__PURE__ */ t.createElement(f, l({}, o, {
    motionAppear: !0,
    visible: r,
    removeOnLeave: !0
  }), function(i) {
    var s = i.className;
    return /* @__PURE__ */ t.createElement("div", {
      style: {
        zIndex: a
      },
      className: c("".concat(n, "-mask"), s)
    });
  }) : null;
}
export {
  k as default
};
//# sourceMappingURL=Mask.mjs.map
